
var PodModalCtrl = function ($scope, $http, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel, podService, timestampUrl, helperFactory) {

    var _this = this;
    var formdata = new FormData();

    if($scope.formModel === undefined) {
        $scope.formModel = passedModel;
    }

    $scope.pods = podService.pods;

    $scope.cancel = function(e) {
        if(angular.isDefined(e)){
            e.preventDefault();
        }
        $uibModalInstance.dismiss('cancel');
    };

    $scope.podTypeChanged = function() {
        $scope.formModel.editorLoaded = false;
        $scope.formModel.editLink = timestampUrl.add($scope.formModel.editLinkTemplate + $scope.formModel.podType);
    };

    $scope.initEditLink = function(editLinkTemplate, podType) {
        $scope.formModel.editLinkTemplate = editLinkTemplate;
        $scope.formModel.podType = podType;
        $scope.podTypeChanged();
    };

    $scope.delete = function(url) {
        ajaxCall.getData(url, $scope.formModel).then(
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "success", bodyHtml: "Pod deleted", timeout:10});
                podService.removePod($scope.formModel.id);
                $scope.cancel();
            },
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "danger", bodyHtml: "Failed to delete pod", timeout:10});
                $scope.cancel();
            }
        );

    };

    $scope.reset = function(url) {
        ajaxCall.getData(url, $scope.formModel).then(
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "success", bodyHtml: "Pod reset to organisation defaults", timeout:10});
                podService.resetPod($scope.formModel.id, result.data);
                $scope.cancel();
            },
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "danger", bodyHtml: "Failed to reset pod", timeout:10});
                $scope.cancel();
            }
        );

    };

    $scope.save = function(url) {
        ajaxCall.getData(url, $scope.formModel, true).then(
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "success", bodyHtml: "Pod configuration saved", timeout:10});
                podService.updateOrAddPod(result.data, $scope.formModel.id);
                xmsNotificationFactory.bulk(result.attachmentErrors);
                $scope.cancel();
            },
            function(result) {
                xmsNotificationFactory.addObj({id: "fieldControlPop", type: "danger", bodyHtml: "Failed to save pod configuration", timeout:10});
            }
        );
    }

    $scope.insertToken = function(updateExpression, locals) {
       $scope.$eval(updateExpression, locals);
    }

    $scope.copyByVal = function(src){
      return angular.copy(src);
    }

    // duplicated from app.js as modal window doesn't have the access to the main scope
    // TODO: move to the config
    // TODO: this should now work with the main ocLoadModal as modal has been rewritten to inherited scope
    $scope.ocLoadModal = {
        angularUiTree: {name:'angularUiTree', files:[
                WEBAPP_PATH + '/js/vendor/angular/angular-ui-tree/angular-ui-tree.min.js'
            ]
        }
    };

};
PodModalCtrl.$inject = ['$scope','$http','ajaxCall','xmsNotificationFactory', '$uibModalInstance','params', 'podService', 'timestampUrl', 'helperFactory'];
angular.module('app').controller('PodModalCtrl',PodModalCtrl);
